export default "__VITE_ASSET__DSVMW7YM__"